import { useRouteMatch } from "react-router-dom";
import { appConfig } from "../../InitData";
import { concatUrlPathnames } from "../sport-utils";
import { getConfiguration, getEncodedURI } from "../utils";
import { systemCode } from "../..";
import { isSeoUrlDisabled } from "./seoUtils";

export function useAbsolutePath(urlPath,parents,urlPathSeo,useRelative=false){
    let toReturn = '';

    try {
        const routeMatch = useRouteMatch();
        let routeUrl = routeMatch?routeMatch.url:"";
        /*if(routeUrl === '/')
            routeUrl = '';*/
        if(appConfig.ROUTES.routeFromPath (routeUrl) === 'prematch'){
            routeUrl = appConfig.ROUTES.prematch['prematch'] || appConfig.ROUTES.prematch['top-match'];
        }
        
        let p;
        let m;

        if(getConfiguration().seo && !isSeoUrlDisabled(systemCode) && (urlPathSeo || null) != null){
            urlPathSeo = getEncodedURI(urlPathSeo);
            if(urlPathSeo.startsWith('/')){
                if(useRelative){
                    toReturn = appConfig.BASENAME === '/'? urlPathSeo: urlPathSeo.replace(appConfig.BASENAME,'')
                }else{
                    toReturn = urlPathSeo;
                }
            }else{
                toReturn = concatUrlPathnames(useRelative?'':appConfig.BASENAME,routeUrl, urlPathSeo);
            }
        }else{
            p = routeUrl==urlPath?routeUrl:concatUrlPathnames(routeUrl, urlPath);
            if(appConfig.URL_PATH_MAPPINGS){
                m = Object.keys(appConfig.URL_PATH_MAPPINGS).find(function(k){return appConfig.URL_PATH_MAPPINGS[k]==p});
            }
            if(window.seoConfig && window.seoConfig.ump && parents){
                parents.forEach(function(parent){
                    let s = concatUrlPathnames(routeMatch?routeMatch.url:"", parent['path'],parent['suffix']);
                    //let ms = Object.keys(appConfig.URL_PATH_MAPPINGS).find(function(k){return appConfig.URL_PATH_MAPPINGS[k]==s});
                    let ms = Object.keys(window.seoConfig.ump).find(function(k){return window.seoConfig.ump[k]==s});
                    if(ms){
                        p = p.replace(concatUrlPathnames(routeUrl,parent['path']),ms);
                    }
                })
            }/*else{
                if(appConfig.URL_PATH_MAPPINGS){
                    m = Object.keys(appConfig.URL_PATH_MAPPINGS).find(function(k){return appConfig.URL_PATH_MAPPINGS[k]==p});
                }
            }*/
            toReturn = concatUrlPathnames(useRelative?'':appConfig.BASENAME, (m||p));
        }
    }catch(err) {
        console.log(err);
        toReturn = '';
    }

    
    
    
    return toReturn;
}